export const FOOTER_NAV_LOCATION_ID = 'footer_nav'
export const MOBILE_FOOTER_NAV_LOCATION_ID = 'mobile_footer_nav'

export const FOOTER_LOGO_BUTTON_ID = 'footer_logo_button'
export const FOOTER_TOGGLE_BUTTON_ID = 'footer_toggle_button'

export const FACEBOOK_BUTTON_ID = 'facebook_button'
export const GOOGLE_MAPS_BUTTON_ID = 'google_maps_button'
export const NEXTDOOR_BUTTON_ID = 'nextdoor_button'
export const PAY_BILL_BUTTON_ID = 'pay_bill_button'
